import { NotificationsProvider, ThemeDescriptor, ThemeProvider } from '@isbj-redesign/shared-components'
import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { AuthProvider } from './auth'
import BrowserCheck from './browsercheck'
import Dokumente from './DokumentePage'
import { EncryptionProvider } from './EncryptionProvider'

const queryClient = new QueryClient()

const themes: ThemeDescriptor[] = [
    { id: 'default', label: 'Standard' },
    { id: 'contrast', label: 'Hoher Kontrast' },
]

export default function App() {
    return (
        <ThemeProvider themes={themes}>
            <BrowserRouter>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <NotificationsProvider>
                            <EncryptionProvider>
                                <Switch>
                                    <Route path="/browsercheck">
                                        <BrowserCheck />
                                    </Route>
                                    <Route path="/">
                                        <Dokumente />
                                    </Route>
                                </Switch>
                            </EncryptionProvider>
                        </NotificationsProvider>
                    </AuthProvider>
                </QueryClientProvider>
            </BrowserRouter>
        </ThemeProvider>
    )
}
